import styled from 'styled-components';

const NavPanelStyled = styled.div(({ theme }) => ({
  background: theme.color.wfBlack,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100%',
  width: 40,
}));

export { NavPanelStyled };
